(function () {
    document.querySelectorAll('[data-cross-sell]').forEach(function (root) {
      if (root.dataset.loaded) return;
      const productId = root.dataset.productId;
      const sectionId = root.dataset.sectionId;
      const limit = root.dataset.limit || '4';
      if (!productId) return;

      const url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
        'recommendations/products?section_id=' + encodeURIComponent(sectionId) +
        '&product_id=' + encodeURIComponent(productId) +
        '&intent=complementary' +
        '&limit=' + encodeURIComponent(limit);

      function load() {
        if (root.dataset.loaded) return;
        root.dataset.loaded = 'true';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('[data-cross-sell]');
            // Only inject when the fetched section actually has products. An empty
            // complementary result would otherwise leave the section's padded,
            // colour-schemed band on the page with no content.
            if (fresh && fresh.querySelector('[data-cross-sell-strip]')) {
              root.replaceChildren(...Array.from(fresh.childNodes).map(function (n) { return n.cloneNode(true); }));
            } else {
              root.style.display = 'none';
            }
          })
          .catch(function () { root.style.display = 'none'; });
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { load(); io.disconnect(); }
          });
        }, { rootMargin: '300px' });
        io.observe(root);
      } else {
        load();
      }
    });
  })();
